module.exports = __webpack_public_path__ + "static/img/30010 (2).00c0a26.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30010 (2).webp
// module id = TrMg
// module chunks = 14